import React from 'react';
import Flatpickr from 'react-flatpickr';
import useForceUpdate from '@fec/frontend/foundation/hooks/ForceUpdate';
import { German } from '../_flatpickr/l10n/de.js';
import { Rumantsch } from '../_flatpickr/l10n/rm.js';
import './rangecalendar.scss';

const RangeCalendar = ({
  onChange = () => {},
  value = [],
  businessUnit = 'srf',
  minDate = '1940-01-01', // default value determined by PL
  maxDate = 'today',
}) => {
  const forceUpdate = useForceUpdate();

  const options = {
    inline: true, // We want it to be open all the time
    mode: 'range',
    static: true,
    disableMobile: true, // Do not use native mobile date picker components
    altInputClass:
      'input-field__text input-field--icon-date range-calendar__input-field',
    altInput: true,
    altFormat: 'd.m.Y',
    dateFormat: 'Y-m-d',
    minDate: minDate,
    maxDate: maxDate,
    locale: businessUnit === 'rtr' ? Rumantsch : German,
  };

  const onReadyHandler = (instance) => {
    // forcing the component to re-render
    forceUpdate();

    // the current year should be chosen in a dropdown instead of a numerical input.
    // flatpickr does not support that, so we build a custom year dropdown.

    // first we hide flatpickrs own year input field
    instance.currentYearElement.parentElement.style.display = 'none';

    // then we generate and append a custom year dropdown
    generateCustomYearDropdown(instance);
  };

  const generateCustomYearDropdown = (instance) => {
    const start = new Date(minDate).getFullYear();
    const end = new Date().getFullYear();

    instance.yearDropdown = instance._createElement(
      'select',
      'flatpickr-monthDropdown-months flatpickr-monthDropdown-years',
    );

    instance.yearDropdown.tabIndex = -1;

    for (let i = end; i >= start; i--) {
      let option = document.createElement('option');
      option.value = i;
      option.text = i;
      option.classList.add('flatpickr-monthDropdown-month');
      instance.yearDropdown.appendChild(option);
    }

    instance.yearDropdown.addEventListener('change', function (evt) {
      let year = evt.target.options[evt.target.selectedIndex].value;
      instance.changeYear(parseInt(year, 10));
    });

    instance.currentYearElement.parentElement.parentElement.appendChild(
      instance.yearDropdown,
    );
  };

  const updateCustomYearDropdown = (instance) => {
    instance.yearDropdown.value = instance.currentYear;
  };

  const onValueUpdate = (selectedDates, dateStr, instance) => {
    // update the custom year dropdown too if the flatpickr date changes
    updateCustomYearDropdown(instance);
  };

  const onYearChange = (selectedDates, dateStr, instance) => {
    // update the custom year dropdown too if the year changes (i.e. via next/prev month buttons)
    updateCustomYearDropdown(instance);
  };

  return (
    <Flatpickr
      value={value}
      options={options}
      onClose={() => {}}
      onValueUpdate={onValueUpdate}
      onYearChange={onYearChange}
      onChange={onChange}
      onReady={(selectedDates, dateStr, instance) => {
        onReadyHandler(instance);
      }}
    />
  );
};

export default RangeCalendar;
